<template>
	<chart-bar :chartData="chartData" :options="options" />
</template>
<script>
	import ChartBar from './chart-bar.vue';
	import { chunk } from 'lodash';

	export default {
		props: ['data', 'type'],
		inject: ['vigencia', 'mapVigencia'],
		components: { ChartBar },
		data() {
			return {
				colorDeptos: {
					DESEG: '#f44336',
					DESAU: '#9c27b0',
					DECOM: '#673ab7',
					DEGER: '#e91e63',
					DELOG: '#00bcd4',
					DEOFF: '#009688',
					DEFIN: '#4caf50',
					DEREH: '#8bc34a',
					DECON: '#2196f3',
					DEFAT: '#ffeb3b',
					SMS: '#ff9800',
					DEMAR: '#ff5722',
					DESUP: '#795548',
					DEV: '#9e9e9e',
					RPBC: '#607d8b',
					SUPRI: '#00e676',
					FARMA: '#c6ff00',
					DEFIS: '#880e4f',
				},
			};
		},

		computed: {
			chunkVigencia() {
				// return this.vigencia
				return chunk(this.vigencia, 6)[1];
			},
			options() {
				return {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						position: 'right',
					},
				};
			},
			chartData() {
				return {
					labels: this.chunkVigencia.map((item) => item.xDate),
					datasets: this.mountDataSets(this.type),
				};
			},
		},
		methods: {
			mountDataSets(type) {
				let datasets = [];
				for (let depto in this.colorDeptos) {
					datasets.push({
						label: depto,
						backgroundColor: 'rgba(0, 0, 0, 0)',
						borderColor: this.colorDeptos[depto],
						data: this.chunkVigencia.reduce((acc, item) => {
							// console.log(this.data, this.type)

							const value = this.data[type].find(
								(itemData) =>
									itemData.event == item.date &&
									itemData.titulo == depto
							);

							if (value == null) acc.push(0);
							else acc.push(value.total);

							return acc;
						}, []),
					});
				}

				return this.claerData(datasets);
			},
			claerData(datasets) {
				return datasets.filter(
					(item) => JSON.stringify(item.data) != '[0,0,0,0]'
				);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/components/ordem-de-servico.vue